import type { ConsumeFailure, ConsumeResult, ConsumeSuccess } from "@tgame-001/shared-types";
import { apiPost, ApiError } from "./client";

export type { ConsumeSuccess, ConsumeFailure, ConsumeResult };

export async function consume(itemId: string): Promise<ConsumeResult> {
  // Backend zwraca 422 z {ok:false,...} dla failed action.
  // Klient traktuje to jako typed result, nie throw.
  try {
    return await apiPost<ConsumeSuccess>("/api/items/consume", { itemId });
  } catch (err) {
    if (err instanceof ApiError && err.status === 422 && err.body) {
      return err.body as ConsumeFailure;
    }
    throw err;
  }
}
